module.exports = __webpack_public_path__ + "img/MEDIA029.ad0d90b7.jpg";